// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__Erugh","tabTitle":"Tab_tabTitle__2Kgq6","center":"Tab_center__yTN9d"};